import { Alert, Snackbar } from "@mui/material";
import { observer } from "mobx-react-lite";

import { useLabel } from "@mr-portfolio-infrastructure/translations/use-label";
import { useStores } from "@mr-portfolio-store/use-stores";

const autoHideMilliseconds = 5000;

export const NotificationSnackbar = observer(function NotificationSnackbar(): React.JSX.Element | null {
  const { notificationStore } = useStores();
  const getLabel = useLabel();
  const notification = notificationStore.current;

  if (notification === null) {
    return null;
  }

  const messageText = notification.messageText ?? (notification.messageKey !== null ? getLabel(notification.messageKey) : "");

  return (
    <Snackbar
      key={notification.notificationId}
      open
      autoHideDuration={notification.severity === "error" ? null : autoHideMilliseconds}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_event, reason) => {
        if (reason !== "clickaway") {
          notificationStore.dismissCurrent();
        }
      }}
    >
      <Alert variant="filled" severity={notification.severity} onClose={() => notificationStore.dismissCurrent()}>
        {messageText}
      </Alert>
    </Snackbar>
  );
});
